// Site Configurations for Shop Marriott
// -- These values are unique for each site and rarely need to be changed after initial setup
// -- They are passed to the coreContext in _app.tsx and can be accessed in hah-fe-core via the useContext hook

import type { RumConfig } from '@Hotels-at-Home/hah-fe-core/dist/hooks/useRumScript';

export const csrEmail = 'customer.service@shopmarriott.com';
export const siteName = 'Shop Marriott'; // Used in meta tags, for copy interpolation, etc.
export const parentHotelCompany = 'Marriott';
export const hotelBrandName = 'Marriott Hotels';
export const catalogId = 'MAR';
export const region = 'EU';
export const scandiWebMenuId = 'mareu';
export const companyTelephone = '+33 1 41515153';

export const LOGO_IMAGE = { src: '/images/misc/shop-marriott-logo.svg', alt: '' };

// Product/Category Page Settings
// - imageWidth/imageHeight set the size of the <img /> on cat/prod pages to prevent layout shift
export const product = {
  imageWidth: 1123,
  imageHeight: 732,
  imageWidthThumbnail: 500,
  almaWidget: true,
};

export const category = {
  imageEagerLoadingAmount: 3,
};
export const cart = {
  counterButtons: true,
  drawerContinueShopping: false,
  useCartDrawer: true,
  staticQuantity: true,
  ymalName: 'MAREU - Cart',
  disableCartYmals: true,
  drawerTotalInBUtton: false,
};

export const checkout = {
  placeholderLabels: true,
  radioButtons: true,
  showEditButton: true,
  paymentMethodProceedButton: true,
};

export const header = {
  leftDrawerUtilities: true,
};

// Misc
export const firstVisitModal = {
  modalWidth: 599,
};

// font-family name for the body and heading fonts.
// This is used in "src/ui/layouts/App.tsx" to prevent a flash of text-decorations (ex, line-through) before the font is loaded
export const bodyFontName = 'Effra-Regular';
export const headingFontName = 'Effra-Regular';

// Adobe Launch Settings
// - Remove these lines completely if this is not a Marriott site
export const enableBonvoyNumber = true;
export const enableMarriottAdobeLaunch = true;
export const enableBonvoyLoyaltyProgramme = true;
export const account = {
  disableAccountDrawer: false,
  enableWelcomeMessage: true,
};
export const marriottAdobeLaunchBrandCode = 'MC';
export const marriottAdobeLaunchBrandName = 'Marriott Hotels & Resorts';

// Google Tag Manager & Analytics Settings
export const enableGoogleTagManager = true;
export const googleTagManagerId = 'GTM-PRHGFFT';
export const productNameFilters = {
  replacements: [{ target: 'The Marriott', replacement: 'Marriott' }],
  splits: [{ split: ' - ', keepIndex: 0 }],
};

// CloudWatch RUM (Real User Monitoring)
// Loaded by useRumScript hook in App.tsx, gated on Cookiebot statistics consent.
// AppMonitor ID and identity pool ID are public identifiers (they ship in the client
// bundle); see cloudwatch-rum-gdpr-investigation.md in hah-docs for rationale.
export const cloudWatchRum: RumConfig = {
  applicationId: '8eb8541d-4341-4e98-8fd2-aec67a4aea17',
  region: 'eu-central-1',
  identityPoolId: 'eu-central-1:9a1b3829-11c8-4a06-b474-df9fd49dc0d1',
};

// Cookie Restorer for Safari ITP
export const cookieRestorerEnabled = true;
export const cookieRestorerOptions = { options: { interval: 5000 } };

// Meta Tags
export const googleSiteVerification = '';
export const defaultOgImage = '/images/homePage/heroSection/bed-background.jpg';

// Links to international sites
export const INTL_SITES = [
  {
    region: 'NA',
    links: [
      { value: 'U.S.A.', url: 'https://www.shopmarriott.com/index.aspx?referrer=eu' },
      { value: 'Canada', url: 'https://canada.shopmarriott.com/index.aspx?referrer=eu' },
    ],
  },
  {
    region: 'APAC',
    links: [
      { value: 'English', url: 'https://www.shopmarriott.cn/en/?___store=marcn_en' },
      { value: '简体中文', url: 'https://www.shopmarriott.cn/zh-CN/?___store=marcn_zh' },
    ],
  },
];

export const zendeskKey = '602463eb-fce6-453c-a310-ce833e46f282';
